import Footer from "../../components/Footer";
import Navbar from "../../components/NavBar";
import SdaApp from "../../assets/Images/sdaapp.png";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { createScholarship } from "../../actions/scholarship";
import SnackbarComponent, { SnackbarMessage } from "../../components/Snackbar";
import { uploadImageToBackend } from "../../constants/UploadAwsImage";

const initialFormData = {
  full_name: "",
  date_of_birth: "",
  email_address: "",
  phone_number: "",
  gpa: "",
  intended_major: "",
  intended_university: "",
  question_one: "",
  question_two: "",
  question_three: "",
  unofficial_transcripts: null as File | null,
};

const ScholarshipAppForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const dispatch = useDispatch<AppDispatch>();
  const { status, error } = useSelector(
    (state: RootState) => state.scholarships
  );
  const [snackbarMessage, setSnackbarMessage] =
    useState<SnackbarMessage | null>(null);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    if (
      name === "unofficial_transcripts" &&
      e.target instanceof HTMLInputElement &&
      e.target.files
    ) {
      setFormData({
        ...formData,
        date_of_birth: new Date(formData.date_of_birth)
          .toISOString()
          .split("T")[0],
        [name]: e.target.files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    let imageUrl = "";
    if (formData.unofficial_transcripts) {
      imageUrl = await uploadImageToBackend(
        formData.unofficial_transcripts,
        "unofficial_transcripts"
      );
    }

    const formattedData = {
      ...formData,
      unofficial_transcripts: imageUrl,
      date_of_birth: formData.date_of_birth,
    };

    dispatch(createScholarship(formattedData)).then((response) => {
      if (response.type.includes("fulfilled")) {
        setSnackbarMessage({
          message: "Scholarship Application created successfully!",
          severity: "success",
        });
        setFormData(initialFormData);
      } else {
        setSnackbarMessage({
          message: "Error creating Scholarship Application",
          severity: "error",
        });
      }
    });
  };
  return (
    <div>
      <Navbar />
      <div className="flex flex-col justify-center items-center">
        <img
          src={SdaApp}
          className="w-[30%] my-6 cursor-pointer"
          alt="SDA App Header"
          onClick={() => navigate("/")}
        />
        <form
          onSubmit={handleSubmit}
          className="max-w-6xl w-full mx-auto p-6 bg-white shadow-md rounded-lg space-y-4"
        >
          <h2 className="text-2xl font-semibold mb-4">
            Scholarship Application
          </h2>

          <div>
            <label className="block text-gray-700 font-bold">Full Name</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-bold">
              Date of Birth
            </label>
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleChange}
              max={new Date().toISOString().split("T")[0]}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-bold">
              Email Address
            </label>
            <input
              type="text"
              name="email_address"
              value={formData.email_address}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-bold">
              Phone Number
            </label>
            <input
              type="text"
              name="phone_number"
              value={formData.phone_number || ""}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-bold">Current GPA</label>
            <input
              type="text"
              name="gpa"
              value={formData.gpa}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-bold">
              Intended Major
            </label>
            <input
              type="text"
              name="intended_major"
              value={formData.intended_major}
              onChange={handleChange}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label
              htmlFor="intended_university"
              className="block text-gray-700 font-bold"
            >
              Intended University
            </label>
            <select
              id="intended_university"
              name="intended_university"
              value={formData.intended_university}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            >
              <option value="">Select a university</option>
              <option value="USC">
                University of Southern California (USC)
              </option>
              <option value="UNLV">
                University of Nevada, Las Vegas (UNLV)
              </option>
              <option value="CSUS">
                California State University, Sacramento (CSUS)
              </option>
              <option value="CSUF">
                California State University, Fullerton (CSFU)
              </option>
              <option value="CPP">
                California State Polytechnic University, Pomona (CPP)
              </option>
            </select>
          </div>
          <div>
            <p className="block text-gray-700 font-bold text-xl text-center">
              Short Response Questions
            </p>
            <p className="block text-gray-700 font-bold text-center">
              Please provide thoughtful and detailed responses to the following
              questions. Each response should be between 200-400 words.
            </p>
            <label className="block text-gray-700 ">
              Question One: Sigma Delta Alpha Fraternity, Inc. was founded with
              the primary goal of ensuring that members of underserved
              communities not only attend but graduate institutions of higher
              learning. How do you plan to help both yourself and other
              underserved students achieve academic success?
            </label>
            <textarea
              name="question_one"
              value={formData.question_one}
              onChange={handleChange}
              rows={8}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div>
            <label className="block text-gray-700 ">
              Question Two: How do you plan to use your education and
              experiences at a university to create a positive impact on your
              community or other underserved groups?
            </label>
            <textarea
              name="question_two"
              value={formData.question_two}
              onChange={handleChange}
              rows={8}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div>
            <label className="block text-gray-700 ">
              Question Three: Briefly describe your family's economic
              background. Include information about financial challenges that
              have impacted your ability to pursue higher education.
            </label>
            <textarea
              name="question_three"
              value={formData.question_three}
              onChange={handleChange}
              rows={8}
              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 ">
              <strong>Unofficial Transcripts</strong> (Accepts PDF, JPEG, PNG)
            </label>
            <input
              type="file"
              name="unofficial_transcripts"
              accept="application/pdf,image/*"
              onChange={handleChange}
              className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
            />
          </div>

          <button
            type="submit"
            className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Submit Application
          </button>
          <p className="text-center">
            **{" "}
            <strong>
              The scholarship is contingent upon the applicant enrolling in and
              attending the university specified in their application. Failure
              to do so may result in the scholarship being revoked at our
              discretion.
            </strong>{" "}
            **
          </p>
          <p className="text-center">
            If experiencing any technical difficulties trying to submit
            application, please email us at{" "}
            <a
              href="mailto:sda.nationalpresident@gmail.com"
              className="text-blue-600 underline"
            >
              sda.nationalpresident@gmail.com
            </a>
          </p>
        </form>
      </div>
      <Footer />
      <SnackbarComponent
        snackbarMessage={snackbarMessage}
        onClose={() => setSnackbarMessage(null)}
      />
    </div>
  );
};

export default ScholarshipAppForm;
